<template>
	<div class="flex_1 margin_horizontal">
		<AccessRestrictedTabs class="table_tabs"
							  v-model="activeTab"
							  :elements="tabTypes"
							  :session-key="$route.path"
		/>
		<MarketSoundingDecisionTable v-if="activeTab === tabTypes.marketSoundingDecisions"/>
		<CustomRatingTableWithFilter v-if="activeTab === tabTypes.ratings"/>
		<InvestorSellerDebtorConfigTable key="seller" v-if="activeTab === tabTypes.seller" :tab-type="tabTypes.seller.name"/>
		<InvestorSellerDebtorConfigTable key="debtor" v-if="activeTab === tabTypes.debtor" :tab-type="tabTypes.debtor.name"/>
		<IndustryBlacklist v-if="activeTab === tabTypes.industryBlacklist"/>
	</div>
</template>

<script>
import CustomRatingTableWithFilter from "@/components/templates/investor/riskAssessment/customRatings/CustomRatingTableWithFilter.vue";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {enumDef} from "@/common/enumDefs";
import {navigationTabs} from "@/common/navigation/navigationTabs";
import IndustryBlacklist from "@/components/templates/investor/riskAssessment/industryBlacklist/IndustryBlacklist.vue";
import InvestorSellerDebtorConfigTable
	from "@/components/templates/investor/riskAssessment/marketSounding/InvestorSellerDebtorConfigTable.vue";
import {hasAccess} from "@/common/permission/permission";
import {riskAssessmentApi} from "@/common/api/riskAssessmentApi";
import MarketSoundingDecisionTable
	from "@/components/templates/investor/riskAssessment/marketSounding/MarketSoundingDecisionTable.vue";
import {marketSoundingDecisionApi} from "@/common/api/marketSoundingDecisionApi";

export default {
	components: { MarketSoundingDecisionTable, InvestorSellerDebtorConfigTable, IndustryBlacklist, CustomRatingTableWithFilter, AccessRestrictedTabs },
	data() {
		let tabTypes = {
			marketSoundingDecisions: {
				name: navigationTabs.investor.riskAssessment.marketSoundingDecisions,
				translationKey: "riskAssessment.tab.marketSoundingDecisions",
				permission: enumDef.permissions.InvestorCustomRatings,
				count: null,
			},
			seller: {
				name: navigationTabs.investor.riskAssessment.seller,
				translationKey: "riskAssessment.tab.seller",
				permission: enumDef.permissions.InvestorCustomRatings,
				count: null,
			},
			debtor: {
				name: navigationTabs.investor.riskAssessment.debtor,
				translationKey: "riskAssessment.tab.debtor",
				permission: enumDef.permissions.InvestorCustomRatings,
				count: null,
			},
			ratings: {
				name: navigationTabs.investor.riskAssessment.customRatings,
				translationKey: "riskAssessment.tab.ratings",
				permission: enumDef.permissions.InvestorCustomRatings,
				count: null,
			},
			industryBlacklist: {
				name: navigationTabs.investor.riskAssessment.industryBlacklist,
				translationKey: "riskAssessment.tab.industryBlacklist",
				permission: enumDef.permissions.InvestorCustomRatings,
				count: null,
			}
		};

		return {
			tabTypes: tabTypes,
			activeTab: null
		};
	},
	created() {
		this.updateCounts()
	},
	methods: {
		updateCounts() {
			if (hasAccess(this.currentUser, enumDef.permissions.InvestorCustomRatings)) {
				riskAssessmentApi.inspection.getCounts()
					.then(counts => {
						this.tabTypes.seller.count = counts.sellerCount;
						this.tabTypes.debtor.count = counts.debtorCount;
					});
				marketSoundingDecisionApi.inspection.getCountNew()
					.then(count => {
						this.tabTypes.marketSoundingDecisions.count = count;
					});
			}
		}
	}
};
</script>